import {createApp} from '../../../../../vendor/Vue3/vue.esm-browser.prod.min.js';
import {get} from "../../../../../shared/js/data-manager";

export default class Search {
    constructor($el) {
        this.$container = $el;
        this.maxPerSection = Number($el.dataset.maxPerSection || 0);
        this.createVueApp();
    }

    createVueApp() {
        const maxPerSection = this.maxPerSection;
        const app = createApp({
            data() {
                return {
                    searchTerm: '',
                    showSidebar: false,
                    results: {},
                    totalResults: 0,
                    isLoading: false,
                    maxPerSection,
                };
            },
            computed: {},
            methods: {
                search() {
                    this.isLoading = true;

                    clearTimeout(this.searchTimeout);
                    this.searchTimeout = setTimeout(() => {
                        this.performSearch();
                    }, 200);
                },
                async performSearch() {
                    this.isLoading = true;
                    this.results = {};
                    this.totalResults = 0;
                    this.syncSearchTermToUrl();

                    const url = new URL(`${baseHref}/ajax/search`);

                    if (this.abortController) {
                        this.abortController.abort();
                    }

                    const abortController = new AbortController();
                    this.abortController = abortController;
                    const query = {q: this.searchTerm || ''};
                    
                    try {
                        const result = await get(url.toString(), query, abortController.signal);

                        if (result) {
                            result.tabs.forEach((tab) => {
                                if (tab.count) {
                                    const max = this.maxPerSection;
                                    this.results[tab.title] = max ? tab.data.slice(0, max) : tab.data;
                                    this.totalResults += tab.count;
                                }
                            })
                        }

                    } catch (error) {
                        if (error.name !== 'AbortError') {
                            throw error;
                        }
                    } finally {
                        if (this.abortController === abortController) {
                            this.isLoading = false;
                        }
                    }
                },
                syncSearchTermToUrl() {
                    const url = new URL(window.location.href);

                    if (this.searchTerm) {
                        url.searchParams.set('q', this.searchTerm);
                    } else {
                        url.searchParams.delete('q');
                    }

                    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
                },
                toggleSidebar() {
                    this.showSidebar = !this.showSidebar;

                    if (this.showSidebar) {
                        document.querySelector('[data-search-input]').focus();
                    }
                },
                getHrefForItem(item) {
                    return item.href[locale];
                }
            },
            async mounted() {
                const url = new URL(window.location.href);
                this.searchTerm = url.searchParams.get('q') || '';

                this.performSearch();
            },
        });

        app.config.compilerOptions.delimiters = ['v{', '}'];

        // mount the app
        app.mount(this.$container);
    }

}
